import React from "react";

export default function WhatIDo() {
    return (
        <section
            id="what-i-do"
            data-testid="what-i-do-section"
            className="section-pad relative"
        >
            <div className="container-edge">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
                    <div className="md:col-span-4">
                        <div className="h-px w-16 bg-foreground/30" />
                    </div>
                    <div className="md:col-span-8">
                        <h2
                            data-testid="what-i-do-heading"
                            className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight font-medium leading-[1.02] text-balance"
                        >
                            Visualising event spaces{" "}
                            <span className="italic font-normal text-champagne">
                                before they exist.
                            </span>
                        </h2>
                        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-8 text-foreground/75 text-[15px] leading-relaxed">
                            <p>
                                I help turn event ideas, venue plans, sketches,
                                references and production requirements into clear 3D
                                visuals, layouts and presentation assets. From simple
                                spatial models to more polished concept visuals, the
                                aim is to make an event easier to understand before
                                it is built.
                            </p>
                            <p>
                                Showing how people move through the space, how key
                                features sit together, how the environment could
                                feel, and how the concept can be communicated to
                                clients, suppliers and production teams. From idea to
                                approval, approval to planning, and planning to site.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
